import { useEffect, useState } from 'react';

export const useBlinkRows = <TId>(rowsIds: TId[]) => {
    const [highlightedRows, setHighlightedRows] = useState<TId[]>([]);

    useEffect(() => {
        if (rowsIds.length) {
            setHighlightedRows(rowsIds);

            const timeout = setTimeout(() => {
                setHighlightedRows([]);
            }, 1000);

            return () => clearTimeout(timeout);
        }
    }, [rowsIds]);

    return { highlightedRows };
};
